/**
 * 公共格式化工具方法
 * 从 Exchange.vue / HighRiskExposureAlert.vue 等多处抽离
 */

/** 格式化分数值，确保输出统一的二位小数格式 */
export const formatScoreValue = (score: number | string): string => {
  const num = typeof score === 'number' ? score : parseFloat(score)
  return isNaN(num) ? '0.00' : num.toFixed(2)
}

/** 将 ARGB 十六进制颜色转换为 CSS RGBA 十六进制颜色；普通 RGB 颜色原样返回 */
export const aRgbToRgba = (color: string): string => {
  const hex = color.trim()
  const value = hex.startsWith('#') ? hex.slice(1) : hex

  if (!/^[\da-fA-F]{8}$/.test(value)) {
    return color
  }

  return `#${value.slice(2)}${value.slice(0, 2)}`
}
